import React, { useEffect } from "react";
import "../../Assets/Styles/pages/landing.scss";
import Banner from "../../Components/TermsComponents/banner";
import Terms from "../../Components/TermsComponents/terms";

const TermsCondition = () => {
	useEffect(() => {
		window.scrollTo(0, 0);
	}, []);

	return (
		<>
			<Banner />
			<Terms />
		</>
	);
};

export default TermsCondition;
